{
  "pagination": {
    "counts": "Showing {first} to {last}",
    "counts_with_total": "Showing {first} to {last} of {total}",
    "rows_per_page": "Rows per page",
    "range": "{first}–{last}",
    "range_with_total": "{first}–{last} of {total}"
  },
  "sort": {
    "label": "Sort",
    "sort_by": "Sort by",
    "a_z": "A-Z",
    "z_a": "Z-A",
    "clear": "Clear sort"
  },
  "search": {
    "label": "Search"
  },
  "filters": {
    "label": "Filters",
    "all": "All",
    "clear": "Clear filters",
    "clear_all": "Clear all"
  },
  "selection": {
    "count": "{count} selected",
    "all_selected": "All selected",
    "select_all": "Select all",
    "select_all_matching": "Select all {count} matching",
    "undo": "Undo",
    "row": "Select row {name}"
  },
  "tree": {
    "expand": "Expand row",
    "collapse": "Collapse row"
  },
  "columns": {
    "title": "Show columns",
    "always_visible": "Always visible"
  },
  "views": {
    "all": "All"
  },
  "empty": {
    "title": "No results found",
    "description": "Try adjusting your search or clearing filters."
  }
}
